import toast from 'react-hot-toast';
import { httpRequest } from 'src/services/httpRequest';
import { PermitFeeTypeName } from 'src/types/RoadPermit/roadPermit.type';

// Get the fees for the current permit
export const getFeesForCurrentPermit = (data) => {
  if (data.length > 0) {
    const updatedFees = data?.reduce((acc, item) => {
      const feeTypeKey = Object.keys(PermitFeeTypeName).find(
        (key) => PermitFeeTypeName[key] === item.FeeTypeName
      );
      if (feeTypeKey) {
        return {
          ...acc,
          [feeTypeKey]: parseFloat(item.FeeValue)
        };
      } else {
        return acc;
      }
    }, {});
    return updatedFees;
  }

};

// Get the application fee
export const getApplicationFee = async (permitId) => {
  const response = await httpRequest(
    'GET',
    `/configuration/fee_details?PermitID=${permitId}`
  );
  if (response?.status === 'success') {
    const feeObject = getFeesForCurrentPermit(response.data);
    return feeObject
  } else if (response?.type === 'NETWORK_ERROR') {
  } else {
    toast.error(response?.message);
  }
};
